import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import useJwt from '../auth/jwt/useJwt'

const LS_KEY = 'bookmakersData'
const LS_TIMESTAMP_KEY = 'bookmakersDataTimestamp'
const TEN_MINUTES = 10 * 60 * 1000

export const fetchBookmakersData = createAsyncThunk(
  'bookmakersData/fetchBookmakersData',
  async () => {
    const now = Date.now()
    const cachedData = JSON.parse(localStorage.getItem(LS_KEY) || 'null')
    const cachedTimestamp = parseInt(localStorage.getItem(LS_TIMESTAMP_KEY) || '0', 10)

    if (cachedData && (now - cachedTimestamp < TEN_MINUTES)) {
      return cachedData
    }

    const response = await useJwt.getBookmakers()
    localStorage.setItem(LS_KEY, JSON.stringify(response.data))
    localStorage.setItem(LS_TIMESTAMP_KEY, now.toString())
    return response.data
  }
)

const bookmakersDataSlice = createSlice({
  name: 'bookmakersData',
  initialState: {
    data: null,
    status: 'idle',
    error: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchBookmakersData.pending, state => {
        state.status = 'loading'
      })
      .addCase(fetchBookmakersData.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
      })
      .addCase(fetchBookmakersData.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
  }
})

export default bookmakersDataSlice.reducer
